// extracted by mini-css-extract-plugin
export var container = "_f9-0";
export var content = "_f9-3";
export var customerTitle = "_f9-4";
export var empty = "_f9-5";
export var gray = "_f9-6";
export var header = "_f9-7";
export var info = "_f9-8";
export var loading = "_f9-2";
export var loadingCard = "_f9-9";
export var oneLine = "_f9-a";
export var personName = "_f9-e";
export var pillContainer = "_f9-b";
export var selected = "_f9-1";
export var text = "_f9-c";
export var twoLines = "_f9-d";
export var unread = "_f9-f";
export var unreadIndicator = "_f9-g";